// combatpro/panels/monsters/studio/MonsterStudioSource.js
//
// Combat PRO - MonsterStudioSource (Stage 56: Editor Runtime Foundation).
//
// The source / status panel, ported from the legacy viStudioRenderSource
// (battletracker.html 10999-11011). A derived read-only display of the current
// editing model: source monster, custom name, storage, status (with the live
// "unsaved" marker driven by the runtime dirty flag), last-saved, and the version
// count. It mutates nothing.
//
// Faithful detail preserved: the status LABEL maps the model's own status field
// ('official'/'unmodified' -> "Official (unmodified)", 'modified' -> "Modified
// Version", else "Custom"), exactly as the legacy panel did. The Custom Name row
// uses the legacy customName || name || em-dash fallback (rendered via the unicode
// escape), which is one of three different name fallbacks in the legacy (see the
// editor runtime note); the prominent hero name consumes the engine display-name
// helper instead.
//
// Last Saved shows "Not saved" in this stage (nothing is saved yet; lastSaved is
// null). The Versions button is inert - version history is a later stage. No DOM,
// no persistence. No optional chaining. No literal em dash.

import React from 'react';

function statusLabel(status) {
  if (status === 'official' || status === 'unmodified') { return 'Official (unmodified)'; }
  if (status === 'modified') { return 'Modified Version'; }
  return 'Custom';
}

function MonsterStudioSource(props) {
  var s = props.model || {};
  var dirty = props.dirty;
  var saved = s.lastSaved ? 'Saved' : 'Not saved';
  var versionCount = (s.versions && s.versions.length) || 0;

  return (
    <div className="vi-st-source" id="vi-st-source">
      <div className="vi-st-src-row"><span>Source Monster</span><b>{s.sourceMonster || 'None (new monster)'}</b></div>
      <div className="vi-st-src-row"><span>Custom Name</span><b>{s.customName || s.name || '\u2014'}</b></div>
      <div className="vi-st-src-row"><span>Storage</span><b>{'\u2601'} Cloud</b></div>
      <div className="vi-st-src-row"><span>Status</span><b>{statusLabel(s.status)}{dirty ? ' \u2022 unsaved' : ''}</b></div>
      <div className="vi-st-src-row"><span>Last Saved</span><b>{saved}</b></div>
      <div className="vi-st-src-row vi-st-src-ver"><span>Versions</span><button className="vi-st-ver-btn" type="button" onClick={props.onVersions}>{'\ud83d\udd58'} {versionCount} saved</button></div>
    </div>
  );
}

export default MonsterStudioSource;
